import { useMemo } from "react";
import { CHART_COLORS } from "@/components/analytics/ChartCanvas";
import type { CreanceByParty } from "@/lib/reporting.api";

export function useCreancesByPartyChartConfig(creances: CreanceByParty[]) {
  const topCreances = useMemo(() => creances.slice(0, 10), [creances]);
  const chartConfig = useMemo(
    () => ({
      type: "bar" as const,
      data: {
        labels: topCreances.map((creance) => creance.partyName),
        datasets: [
          {
            label: "Montant dû (XAF)",
            data: topCreances.map((creance) => creance.totalDue),
            backgroundColor: CHART_COLORS.danger,
            borderRadius: 4,
          },
        ],
      },
      options: {
        indexAxis: "y" as const,
        plugins: { legend: { display: false } },
        scales: {
          x: {
            ticks: { font: { size: 11 }, color: CHART_COLORS.muted },
            grid: { color: CHART_COLORS.grid },
            beginAtZero: true,
          },
          y: {
            ticks: { font: { size: 11 }, color: CHART_COLORS.muted },
            grid: { display: false },
          },
        },
      },
    }),
    [topCreances],
  );

  return { topCreances, chartConfig };
}
